<template>
  <!-- 主页 -->
  <div class="home">
    <!-- bannar+主体 -->
    <div class="bannar">
      <div class="bigtitle">
        <p class="bannerdes1">关于我们</p>
        <p class="bannerdes2">About us</p>
        <div class="bannaerline"></div>
        <p class="bannerdes3">以物联为核心驱动，赋能实体新智造的高新科技企业</p>
      </div>
    </div>
    <!-- 小的栏目a -->
    <div
      class="smTab"
      :class="tabStyle == 1 ? 'smTab' : 'smTab2 tabMove'"
      style="border: 1px solid #dddddd"
    >
      <el-tabs v-model="activeName" @tab-click="tableclick">
        <el-tab-pane label="公司简介" name="item0"></el-tab-pane>
        <el-tab-pane label="企业实力" name="item1"></el-tab-pane>
        <el-tab-pane label="核心成员" name="item2"></el-tab-pane>
        <el-tab-pane label="荣誉资质" name="item3"></el-tab-pane>
        <el-tab-pane label="企业文化" name="item4"></el-tab-pane>
        <el-tab-pane label="大事记" name="item5"></el-tab-pane>
        <el-tab-pane label="团队风采" name="item6"></el-tab-pane>
      </el-tabs>
      <!-- <div class="smallLine"></div> -->
    </div>
    <div :class="tabStyle !== 1 ? 'smTab3' : ''"></div>
    <!-- 1.简介 -->
    <div class="model model1">
      <i class="position"></i>
      <Minetitle :title1="titleArr[0].title1" :title2="titleArr[0].title2" />
      <div class="model1_main clearfix">
        <!-- 视频 -->
        <div v-show="windowWidth > 1400">
          <div class="videoModel" @click="openVideo">
            <video
              style="object-fit: fill"
              src=""
              class="model1_video"
              :poster="videoPoster"
            ></video>
            <img :src="videoPoster" alt="" class="videoPoster2" />
            <img
              src="../../public/img/home/play.png"
              alt=""
              class="btn_playVideo"
            />
          </div>
          <!-- 关于我们 -->
          <div class="model1_floor1">
            <div class="model1_floor1_title">关于我们<b>/ABOUT</b></div>
            <el-input
              type="textarea"
              class="model1_context"
              disabled
              rows="15"
              resize="none"
              v-model="company.context"
              v-show="windowWidth < 1400"
            ></el-input>
            <el-input
              type="textarea"
              class="model1_context2"
              disabled
              rows="15"
              resize="none"
              v-model="company.context"
              v-show="windowWidth > 1400"
            ></el-input>
          </div>
        </div>
        <div v-show="windowWidth < 1400">
          <div class="videoModel videoModel2" @click="openVideo">
            <video
              style="object-fit: fill"
              src=""
              class="model1_video"
              :poster="videoPoster"
            ></video>
            <img :src="videoPoster" alt="" class="videoPoster2" />
            <img
              src="../../public/img/home/play.png"
              alt=""
              class="btn_playVideo"
            />
          </div>
          <!-- 关于我们 -->
          <div class="model1_floor1 model1_floor1_s">
            <div class="model1_floor1_title">关于我们<b>/ABOUT</b></div>
            <el-input
              type="textarea"
              class="model1_context model1_context_s"
              disabled
              rows="15"
              resize="none"
              v-model="company.context"
            ></el-input>
          </div>
        </div>

        <div class="model1_floor2">
          <div v-if="company.imgs.length < 3">
            <img
              class="model1_pic"
              v-for="(item, index) in company.imgs"
              :src="item"
              alt=""
              :key="index"
            />
          </div>
          <swiper
            ref="mySwiper"
            :options="swiperOptions0"
            v-if="company.imgs.length >= 3"
          >
            <swiper-slide v-for="(item, index) in company.imgs" :key="index">
              <img class="model1_pic" :src="item" alt="" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 2.企业实力数据 -->
    <div class="model model2">
      <i class="position"></i>
      <Minetitle :title1="titleArr[1].title1" :title2="titleArr[1].title2" />
      <div class="swiperStrength" v-if="strengthList.length > 0">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in strengthList" :key="item">
            <div class="model2_icon">
              <img
                :src="item.imgs"
                style="width: 100px; height: 100px"
                alt=""
              />
            </div>
            <div class="model2_num">
              <CountTo
                :start-val="0"
                :end-val="item.link"
                :duration="1000"
                :autoplay="true"
                v-if="numStatus[0]"
              ></CountTo
              >+
            </div>
            <p class="model2_line"></p>
            <p class="model2_des">{{ item.context }}</p>
          </div>
        </div>
      </div>
      <div v-else class="tips">暂无数据，敬请期待！</div>
      <!-- <ul class="model2_ul">
        <li class="model2_li">
          <div class="model2_icon"></div>
          <div class="model2_num">
            <CountTo
              :start-val="0"
              :end-val="200"
              :duration="1000"
              :autoplay="true"
              v-if="numStatus[0]"
            ></CountTo>
          </div>
          <p class="model2_line"></p>
          <p class="model2_des">生产基地总面积近4万平方米</p>
        </li>
        <li class="model2_li">
          <div class="model2_icon"></div>
          <div class="model2_num">
            <CountTo
              :start-val="0"
              :end-val="300"
              :duration="1000"
              :autoplay="true"
              v-if="numStatus[1]"
            ></CountTo
            >+
          </div>
          <p class="model2_line"></p>
          <p class="model2_des">员工</p>
        </li>
        <li class="model2_li">
          <div class="model2_icon"></div>
          <div class="model2_num">
            <CountTo
              :start-val="0"
              :end-val="200"
              :duration="1000"
              :autoplay="true"
              v-if="numStatus[2]"
            ></CountTo>
          </div>
          <p class="model2_line"></p>
          <p class="model2_des">43项商标</p>
        </li>
        <li class="model2_li">
          <div class="model2_icon"></div>
          <div class="model2_num">
            <CountTo
              :start-val="0"
              :end-val="20"
              :duration="1000"
              :autoplay="true"
              v-if="numStatus[3]"
            ></CountTo>
          </div>
          <p class="model2_line"></p>
          <p class="model2_des">11项专利9项软著</p>
        </li>
      </ul> -->
    </div>
    <!-- 3.核心成员 -->
    <div class="model model3">
      <i class="position"></i>
      <div class="model3_shadow"></div>
      <Minetitle :title1="titleArr[2].title1" :title2="titleArr[2].title2" />
      <!-- 具体待定 -->
      <div class="model3_bg"></div>
      <div class="model3_swiper">
        <el-carousel
          trigger="click"
          :autoplay="false"
          type="card"
          height="2.5rem"
          arrow="never"
          @change="personChange"
        >
          <el-carousel-item
            v-for="(item, index) in personList"
            :key="index"
            class="personItem"
          >
            <img class="personPic" :src="item.imgs" alt="" />
            <div class="personName">{{ item.title }}</div>
            <div class="personSf">{{ item.remark }}</div>
            <el-input
              type="textarea"
              class="personInfo"
              disabled
              rows="15"
              resize="none"
              v-model="item.context"
            ></el-input>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="item_detail" :class="personInfoStatus ? 'show' : 'hide'">
        {{ personInfo }}
        <div class="item_arrow"></div>
      </div>
    </div>
    <!-- 4.荣誉资质 -->
    <div class="model model4">
      <i class="position"></i>
      <Minetitle :title1="titleArr[3].title1" :title2="titleArr[3].title2" />
      <div class="model4Main">
        <!-- 奖项  -->
        <div class="model4floor clearfix">
          <div class="model4_lf">
            <!-- :interval="2500" -->
            <el-carousel
              height="2.2rem"
              arrow="always"
              :interval="2000"
              @change="honorArr1Change"
              indicator-position="none"
              :autoplay="false"
            >
              <el-carousel-item
                v-for="item in honor"
                :key="item.id"
                class="honorArr1"
              >
                <img class="honorPic" :src="item.imgs" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="model4_rt">
            <!-- <div class="model4_rt_title">获得奖项<b>/ Won awards</b></div> -->
            <vueSeamless :data="honor" :class-option="vueOption">
              <ul class="model4_ul2">
                <li
                  class="model4_li2"
                  v-for="(item, index) in honor"
                  :key="index"
                  @click="gotoDetail(item)"
                >
                  <p
                    class="model4_p1"
                    :class="honorIndex1 == index ? 'fontBlue' : ''"
                  >
                    {{ item.context }}
                  </p>
                  <p class="model4_p2">{{ item.updateTime.slice(0, 10) }}</p>
                </li>
              </ul>
            </vueSeamless>
          </div>
        </div>
      </div>
      <!-- 用于定位同上 -->
    </div>
    <!-- 5.企业文化 -->
    <div class="model model5">
      <div class="model5_shadow"></div>
      <i class="position"></i>
      <Minetitle :title1="titleArr[4].title1" :title2="titleArr[4].title2" />
      <ul class="model5ul">
        <li class="model5li" v-for="item in cultrueArr" :key="item.id">
          <img class="model5icon" :src="picUrl + item.iconUrl" alt="" />
          <p class="model5title">{{ item.title }}</p>
          <p class="model5line"></p>
          <p class="model5des">{{ item.des }}</p>
        </li>
      </ul>
      <i id="position5"></i>
    </div>
    <!-- 6大事记 -->
    <div class="model model6">
      <i class="position"></i>
      <Minetitle :title1="titleArr[5].title1" :title2="titleArr[5].title2" />
      <div class="model6main" v-if="false">
        <!-- 年 -->
        <div class="swiper1">
          <div class="swiper1Line"></div>
          <swiper ref="mySwiper1" :options="swiperOptions1" class="mySwiper1">
            <swiper-slide v-for="(item, index) in xLine" :key="index">
              <li class="list_li1" :class="xIndex == index ? 'fontBlue' : ''">
                <!-- 有三个看不见的点 -->
                <div
                  class="list_li1_name"
                  v-show="index < xLine.length - 3"
                  :class="xIndex == index ? 'fontBlue' : ''"
                >
                  {{ item }}
                </div>
                <div
                  :class="xIndex == index ? 'bgBlue' : ''"
                  class="list_li1_point"
                  v-show="index < xLine.length - 3"
                ></div>
              </li>
            </swiper-slide>
          </swiper>
        </div>
        <!-- 月 -->
        <div class="swiper2">
          <div class="swiper2Line"></div>
          <swiper ref="mySwiper2" :options="swiperOptions2" class="mySwiper2">
            <swiper-slide v-for="(item, index) in yLine" :key="index">
              <li class="list_li2">
                <!-- 有三个看不见的点 -->
                <div
                  class="list_li2_name"
                  :class="yIndex == index ? 'fontBlue' : ''"
                  v-show="index < yLine.length - 3"
                >
                  {{ item }}月
                </div>
                <div
                  class="list_li2_point"
                  :class="yIndex == index ? 'bgBlue' : ''"
                  v-show="index < yLine.length - 3"
                ></div>
              </li>
            </swiper-slide>
          </swiper>
        </div>
        <!-- 日 -->
        <div class="swiper3">
          <swiper ref="mySwiper3" :options="swiperOptions3" class="mySwiper3">
            <swiper-slide v-for="(item, index) in zLine" :key="index">
              <li class="list_li3" @click="gotoDetail(item)">
                <!-- 有三个看不见的点 -->
                <div
                  class="list_li3_month"
                  v-show="index < zLine.length - 3"
                  :class="zIndex == index ? 'fontBlue' : ''"
                >
                  <b
                    class="list_li3_point"
                    :class="zIndex == index ? 'bgBlue' : ''"
                  ></b>
                  {{ item.eventTime }}
                </div>
                <div
                  class="list_li3_thing hidetxt2"
                  :class="zIndex == index ? 'fontBlue' : ''"
                  v-show="index < zLine.length - 3"
                >
                  {{ item.context }}
                </div>
              </li>
            </swiper-slide>
          </swiper>
        </div>
        <el-image
          class="lcPic"
          :src="lcUrl"
          :preview-src-list="lcSrcList"
          style="display: none"
        />
      </div>

      <div class="Memorabilia">
        <div class="changeBtn">
          <el-button type="text" @click="gotoLeft" :disabled="leftDisabled"
            ><img
              src="../assets/leftBtn.png"
              style="width: 40px; height: 40px"
              alt=""
          /></el-button>
          <el-button type="text" @click="gotoRight" :disabled="rightDisabled"
            ><img
              src="../assets/rightBtn.png"
              style="width: 40px; height: 40px"
              alt=""
          /></el-button>
        </div>
        <div class="meContent">
          <div class="contentTop">
            <div class="content-item" v-for="item in topResult" :key="item">
              <div class="des">
                <div class="time">{{ item.year }}年{{ item.month }}月</div>
                <ul>
                  <li
                    v-for="chi in item.monthBigEvents"
                    :key="chi"
                    class="context"
                  >
                    <div class="tip"></div>
                    <div class="txt">{{ chi.context }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="contentBottom">
            <div class="content-item" v-for="item in bottomResult" :key="item">
              <div class="des">
                <div class="time">{{ item.year }}年{{ item.month }}月</div>
                <ul>
                  <li
                    v-for="chi in item.monthBigEvents"
                    :key="chi"
                    class="context"
                  >
                    <div class="tip"></div>
                    <div class="txt">{{ chi.context }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 7团队风采 -->
    <div class="model model7">
      <i class="position"></i>
      <Minetitle :title1="titleArr[6].title1" :title2="titleArr[5].title2" />
      <div class="model7shadow"></div>
      <div class="model7main">
        <el-carousel :interval="3500" type="card" height="4.2rem" arrow="never">
          <el-carousel-item
            v-for="item in actList"
            :key="item.id"
            class="actItem"
          >
            <div @click="gotoDetail(item)" class="actAll">
              <img class="actPic" :src="item.imgs" alt="" />
              <div class="actName">{{ item.context }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 视频 -->
    <el-dialog
      title="视频"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="closeVideo"
    >
      <video :src="videoUrl" class="mineVideo" controls id="video"></video>
    </el-dialog>
  </div>
</template>

<script>
import Minetitle from "../components/minetitle.vue";
import { swiper, swiperSlide, Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getFunc } from "@/api/home";
import { picUrl } from "@/config/env";
import vueSeamless from "vue-seamless-scroll";
import CountTo from "vue-count-to"; //数字滚动
import { postPv } from "@/api/postPv";

// @ is an alias to /src
let _this = null; //自定义this方便swiper使用
export default {
  name: "aboutus",
  data() {
    return {
      vueOption: {
        step: 1,
        limitMoveNum: 3,
        openTouch: false,
        waitTime: 0,
        direction: 1,
        singleHeight: 35,
      },
      numStatus: [false, false, false, false], //20 300 200 20
      windowWidth: "",
      personInfo: "",
      personInfoStatus: false, //默认不显示

      picUrl: "",
      vloading: true,
      tabStyle: 1,
      lcUrl: "", //图片
      lcSrcList: [""], //所有可以预览的图片
      empty: ["", "", ""], //多三个空的让其好滑到最后
      empty2: [{}, {}, {}], //多三个空的让其好滑到最后
      bigItemList: [], // 大事记所有数据
      xLine: [], //年的x轴
      yLine: [], //月的y轴
      zLine: [], //具体每日
      xIndex: 0, //选到的年
      yIndex: 0,
      zIndex: 0,
      //公司图片
      swiperOptions0: {
        slidesPerView: 3,
        spaceBetween: 21,
        loop: true,
        observerParent: true,
        observer: true,
        autoplay: {
          delay: 2000, //自动切换的时间间隔，单位ms自动切换会在slide过渡完毕后才开始计时。
        },
      },
      // 年
      swiperOptions1: {
        slidesPerView: 4,
        spaceBetween: 0,
        loop: false,
        observerParent: true,
        observer: true,
        on: {
          slideChangeTransitionStart: function () {
            //切换年
            let yearIndex = this.activeIndex;
            _this.xIndex = yearIndex; //样式
            _this.yIndex = 0;
            _this.zIndex = 0;
            let data3 = _this.bigItemList;
            let month = data3[yearIndex].monthBigEvents; //
            _this.yLine = []; //先清空
            let yLine = month.map((item) => {
              return item.month;
            });
            yLine = yLine.concat(_this.empty);
            _this.yLine = yLine;
            //console.log(yLine);
            _this.$refs.mySwiper2.swiper.slideTo(0, 1000, false); // 并且让y轴的视图移动到第一页

            let dayArr = month[0].monthBigEvents; //取数据用的//默认切换为第一个

            var new_arr = JSON.parse(JSON.stringify(dayArr));
            let dayArr2 = new_arr.concat(_this.empty2);
            _this.zLine = dayArr2;
            //console.log(dayArr, dayArr2);
            //图片渲染
            _this.lcUrl = dayArr[0].imgs; //图片 图片合集
            _this.lcSrcList = dayArr.map((item) => {
              return item.imgs;
            });
          },
        },
      },
      //月
      swiperOptions2: {
        direction: "vertical",
        slidesPerView: 4,
        spaceBetween: 0,
        loop: false,
        observerParent: true,
        observer: true,
        on: {
          slideChangeTransitionStart: function () {
            //切换月--zline数据改变
            _this.yIndex = this.activeIndex; //样式
            let month = _this.bigItemList[_this.xIndex].monthBigEvents; //
            let dayArr = month[this.activeIndex].monthBigEvents; //取数据用的
            var new_arr = JSON.parse(JSON.stringify(dayArr));
            let dayArr2 = new_arr.concat(_this.empty2);
            _this.zLine = dayArr2;
            //console.log(dayArr, dayArr2);
            //图片渲染
            _this.lcUrl = dayArr[0].imgs; //图片 图片合集
            _this.lcSrcList = dayArr.map((item) => {
              return item.imgs;
            });
          },
        },
      },
      //日
      swiperOptions3: {
        direction: "vertical",
        slidesPerView: 4,
        spaceBetween: 0,
        loop: false,
        observerParent: true,
        observer: true,
        on: {
          slideChangeTransitionStart: function () {
            //切换日
            //console.log(this.activeIndex);
            _this.zIndex = this.activeIndex; //样式
            _this.lcUrl = _this.lcSrcList[this.activeIndex];
          },
        },
      },
      activeName: "item0",
      //题目组
      titleArr: [
        { id: 1, title1: "公司简介", title2: "「我们是谁，我们在做什么」" },
        { id: 2, title1: "企业实力数据", title2: "「我们实力不容小觑」" },
        { id: 3, title1: "核心成员", title2: "Core members" },
        { id: 4, title1: "荣誉资质", title2: "Honor and qualification" },
        { id: 5, title1: "企业文化", title2: "corporate culture" },
        { id: 6, title1: "大事记", title2: "Memorabilia" },
        { id: 7, title1: "团队风采", title2: "Team spirit" },
      ],
      //公司简介
      videoPoster: "", //
      videoUrl: "", //
      dialogVisible: false,
      company: {
        video: "", //video
        context: "",
        imgs: [], //图片合集
      },
      personList: [], //成员
      honor: [], //荣誉资质
      //默认选中第0个为蓝色
      honorIndex1: "",
      cultrueArr: [
        {
          id: 1,
          iconUrl: "/img/aboutwel/icon1.png",
          title: "企业初心",
          des: "以物联为核心驱动\n赋能实体新智造",
        },
        {
          id: 2,
          iconUrl: "/img/aboutwel/icon2.png",
          title: "企业精神",
          des: "成功是拼出来的\n伟大是熬出来的",
        },
        {
          id: 3,
          iconUrl: "/img/aboutwel/icon3.png",
          title: "企业理念",
          des: "重前端业务、造中端内核产品\n强后端运营、融合线上线下平台",
        },
        {
          id: 4,
          iconUrl: "/img/aboutwel/icon4.png",
          title: "企业愿景",
          des: "让新智造更有价值",
        },
      ],
      actList: [], // 团队风采
      strengthList: [], //企业实力
      count: 0, //移动距离
      topResult: [], //奇数月份
      bottomResult: [], //偶数月份
      leftDisabled: true,
      rightDisabled: false, //是否禁用左右箭头
    };
  },
  computed: {
    scrollOption() {
      return {
        step: 0.5,
      };
    },
  },
  created() {
    _this = this;
  },
  inject: ["reload"],
  watch: {},
  methods: {
    getSwiper() {
      var mySwiper = new Swiper(".swiperStrength", {
        loop: false,
        slidesPerView: "auto",
        loopedSlides: 3,
      });
    },
    enters(index) {
      this.personInfoStatus = true;
    },
    leaver(index) {
      this.personInfoStatus = false;
    },
    personChange(index) {
      let personInfo = this.personList[index].context;
      this.personInfo = personInfo;
    },
    gotoDetail(item) {
      //有link需要跳转
      if (typeof item.link == "undefined") {
        return;
      }
      if (item.link !== "") {
        let link = item.link;
        let lastIndex = link.lastIndexOf("/");
        let id = link.slice(lastIndex + 1, link.length);
        this.$router.push({ path: "/newsdetail", query: { id: id } });
        this.$forceUpdate();
        window.scroll(0, 0);
      }
    },
    tableclick(tab) {
      //切换标题栏跳转
      let index = tab.index;
      document
        .getElementsByClassName("position")
        [index].scrollIntoView({ block: "start", behavior: "smooth" });
    },

    closeVideo() {
      this.dialogVisible = false;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.pause();
      });
    },
    openVideo() {
      //打开视频
      this.videoUrl = this.company.videos;
      this.dialogVisible = true;
      this.$nextTick(() => {
        let video = document.getElementById("video");
        video.play();
      });
    },
    honorArr1Change(res) {
      let thiz = this;
      thiz.$nextTick(() => {
        thiz.honorIndex1 = res;
      });
      //第二个也做循环
      // console.log(typeof(res))
      if (res > 0) {
        document.getElementsByClassName("model4_ul2")[1]
          ? document
              .getElementsByClassName("model4_ul2")[1]
              .children[res - 1].children[0].classList.remove("fontBlue")
          : "";
      }
      document.getElementsByClassName("model4_ul2")[1]
        ? document
            .getElementsByClassName("model4_ul2")[1]
            .children[res].children[0].classList.add("fontBlue")
        : "";
      // console.log(res);
    },
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let height = document.getElementsByClassName("bannar")[0].offsetHeight;

      if (scrollTop < height) {
        // //console.log("照常展示");
        this.tabStyle = 1;
        this.activeName = "item0";
      } else {
        this.tabStyle = 2;
      }
      let height1 = document.getElementsByClassName("model1")[0].offsetHeight;
      let height2 = document.getElementsByClassName("model2")[0].offsetHeight;
      let height3 = document.getElementsByClassName("model3")[0].offsetHeight;
      let height4 = document.getElementsByClassName("model4")[0].offsetHeight;
      let height5 = document.getElementsByClassName("model5")[0].offsetHeight;
      let height6 = document.getElementsByClassName("model6")[0].offsetHeight;
      let height7 = document.getElementsByClassName("model7")[0].offsetHeight;
      if (scrollTop > height + height1 - 400) {
        let arr = [true, true, true, true];
        this.numStatus = arr;
      }
      if (scrollTop > height + height1) {
        this.activeName = "item1";
      }
      if (scrollTop > height + height1 + height2) {
        this.activeName = "item2";
      }
      if (scrollTop > height + height1 + height2 + height3) {
        this.activeName = "item3";
      }
      if (scrollTop > height + height1 + height2 + height3 + height4) {
        this.activeName = "item4";
      }
      if (
        scrollTop >
        height + height1 + height2 + height3 + height4 + height5
      ) {
        this.activeName = "item5";
      }
      if (
        scrollTop >
        height + height1 + height2 + height3 + height4 + height5 + height6
      ) {
        this.activeName = "item6";
      }
      if (
        scrollTop >
        height +
          height1 +
          height2 +
          height3 +
          height4 +
          height5 +
          height6 +
          height7
      ) {
        this.activeName = "item7";
      }
    },
    gotoLeft() {
      let dom = document.querySelector(".meContent");

      this.count = this.count == 0 ? 0 : this.count - 1;
      this.leftDisabled = this.count == 0 ? true : false;
      let rate = this.count * 740;
      dom.style.transform = `translateX(-${rate}px)`;
      dom.style.transition = "all 0.5s";
      this.rightDisabled = false;
    },
    gotoRight() {
      let dom = document.querySelector(".meContent");
      let width = dom.offsetWidth;
      this.leftDisabled = false;
      this.count = width >= this.count * 740 ? this.count + 1 : this.count;
      let rate = this.count * 740;
      if (width > rate) {
        console.log(this.count, rate, width);
        dom.style.transform = `translateX(-${rate}px)`;
        dom.style.transition = "all 0.5s";

        let newRate = (this.count + 1) * 740;
        console.log(newRate);
        if (newRate > width) {
          this.rightDisabled = true;
        } else {
          this.rightDisabled = false;
        }
      }
    },
    changeMemorabilia() {
      let result = [];
      this.bigItemList.map((item) => {
        result.push(...item.monthBigEvents);
      });

      let topResult = result.filter((item) => {
        return item.month % 2 == 1;
      });
      let bottomResult = result.filter((item) => {
        return item.month % 2 == 0;
      });
      this.topResult = topResult;
      this.bottomResult = bottomResult;
      console.log(topResult);
      console.log(bottomResult);
    },
  },
  mounted() {
    this.getSwiper();
    postPv("https://www.azureflying.com/api/blade-website/analytics/access")
      .then((res) => {})
      .catch((err) => {});
    //发送pv

    let thiz = this;
    let url1 = "/blade-website/web/index/bigEvent"; //公司简介 :团队风采;2:资质荣誉;3：公司简介；4:核心成员；5：大事件（首页--重要里程）
    let url2 = "/blade-website/web/menu/bigEvent"; //重要里程1 type5

    var type;
    this.$router.onReady(() => {
      type = this.$route.query.keyPath;
    });
    this.$nextTick(() => {
      thiz.windowWidth = document.documentElement.clientWidth;
      window.onresize = () => {
        return (() => {
          thiz.windowWidth = document.documentElement.clientWidth;
          console.log(thiz.windowWidth);
        })();
      };

      this.picUrl = picUrl;
      window.addEventListener("scroll", this.handleScroll);
      //跳转距离
      let typeList = ["2-1", "2-2", "2-3", "2-4", "2-5", "2-6", "2-7"];
      let typeIndex = typeList.indexOf(type);

      getFunc(url1, { type: 3 }).then((res) => {
        if (res.code == 200) {
          const data1 = res.data[0]; //公司简介
          let imgList = data1.imgs.split(",");
          this.company = data1;
          this.videoPoster = imgList[0];
          // console.log(imgList);

          this.company.imgs = imgList;
        }
      });
      getFunc(url1, { type: 8 }).then((res) => {
        if (res.code == 200) {
          thiz.strengthList = res.data;
        }
      });
      //核心成员
      getFunc(url1, { type: 4 }).then((res) => {
        if (res.code == 200) {
          const data2 = res.data;
          // //console.log(data2);
          thiz.personList = data2;
          thiz.personInfo = data2[0].context; //人介绍
        }
      });
      //荣誉资质
      getFunc(url1, { type: 2 }).then((res) => {
        if (res.code == 200) {
          const data3 = res.data;
          thiz.honor = data3;
        }
      });
      //重要里程 type5
      getFunc(url2).then((res) => {
        if (res.code == 200) {
          const data3 = res.data; //大事件（首页--重要里程）
          // //console.log(data3);//整理一下年月日的数组
          this.bigItemList = data3;
          this.changeMemorabilia();
          //x轴-年
          this.xLine = data3.map((item) => {
            return item.year;
          });
          this.xLine.push(...this.empty);
          //y轴-月份 默认取第一个
          this.yLine = data3[0].monthBigEvents.map((item) => {
            return item.month;
          });
          this.yLine.push(...this.empty);
          // //console.log(this.yLine);
          //z轴-天的数据
          let month = data3[0].monthBigEvents; //
          let dayArr = month[0].monthBigEvents; //取数据用的
          var new_arr = JSON.parse(JSON.stringify(dayArr));
          let dayArr2 = new_arr.concat(this.empty2);
          this.zLine = dayArr2;
          // //console.log(dayArr, dayArr2);
          //图片渲染
          this.lcUrl = dayArr[0].imgs; //图片 图片合集
          this.lcSrcList = dayArr.map((item) => {
            return item.imgs;
          });
        }
      });
      //团队风采
      getFunc(url1, { type: 1 })
        .then((res) => {
          if (res.code == 200) {
            const data5 = res.data;
            thiz.actList = data5;
          }
        })
        .then(() => {
          setTimeout(() => {
            document.getElementsByClassName("position")[typeIndex]
              ? document
                  .getElementsByClassName("position")
                  [typeIndex].scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                  })
              : "";
          }, 1500);
        });
      setTimeout(function () {
        document
          .getElementsByClassName("model4_ul2")[1]
          .children[0].remove("fontBlue");
      }, 1000);
    });
  },
  components: { Minetitle, swiper, swiperSlide, picUrl, CountTo, vueSeamless },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
}
.bannar {
  width: 100%;
  position: relative;
  height: 673px;
  background: url(../../public/img/aboutwel/banner.jpg) no-repeat;
  background-size: cover;
}
/* 公司简介 */
.model {
  width: 66%;
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
}

.model1_main {
  width: 100%;
}
.videoModel {
  width: 700px;
  height: 369px;
  float: left;
  margin-bottom: 18px;
  position: relative;
  display: flex;
  justify-items: center;
  align-content: center;
  overflow: hidden;
}
.videoModel:hover .videoPoster2 {
  transform: scale(1.05);
  transition: transform 0.5s linear;
}
.videoPoster2 {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.videoModel video {
  width: 100%;
  height: 100%;
}
.btn_playVideo {
  z-index: 99;
  width: 87px;
  height: 87px;
  position: absolute;
  left: 307px;
  top: 141px;
}

.model1_floor1 {
  width: 525px;
  height: 370px;
  float: right;
  overflow: hidden;
}
.model1_floor1_title {
  margin-bottom: 18px;
  color: #333;
  font-size: 30px;
  line-height: 1;
}
.model1_floor1_title b {
  color: #999999;
  font-size: 18px;
  margin-left: 11px;
}
.model1_context {
  width: 100%;
  height: 305px;
}
.model1_context .el-textarea__inner {
  height: 100% !important;
}

.model1_floor2 {
  width: 100%;
  height: 3.25rem;
  margin-bottom: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.model1_pic {
  width: 413px;
  height: 100%;
}
/*  */
.model2_ul {
  margin-bottom: 99px;
  width: 100%;
  height: 295px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.model2_li {
  width: 224px;
  padding-top: 95px;
  height: 100%;
  text-align: center;
  height: auto;
}
.model2_icon {
  margin-top: 45px;
}

.model2_ul .model2_li:nth-child(1) .model2_icon {
  background: url("../../public/img/home/iconS1.png") no-repeat;
  background-size: cover;
}
.model2_ul .model2_li:nth-child(2) .model2_icon {
  background: url("../../public/img/home/iconS2.png") no-repeat;
  background-size: cover;
}
.model2_ul .model2_li:nth-child(3) .model2_icon {
  background: url("../../public/img/home/iconS3.png") no-repeat;
  background-size: cover;
}
.model2_ul .model2_li:nth-child(4) .model2_icon {
  background: url("../../public/img/home/iconS4.png") no-repeat;
  background-size: cover;
}
.model2_num {
  font-size: 50px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0px;
}
.model2_line {
  width: 16px;
  height: 2px;
  background: #999999;
  border-radius: 16px;
  margin: 0 auto 23px;
}
.model2_des {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  margin-bottom: 100px;
  white-space: nowrap;
}

/* 荣誉资质 */
.model3 {
  /* width: 100%; */
  margin: 0 auto;
  height: 713px;
  padding: 66px 0 0 0;
  position: relative;
}
.model3_shadow {
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: -27%;
  z-index: 1;
  background: #f7f7f7;
}
.model3_bg {
  width: 100vw;
  height: 363px;
  background: url("../../public/img/aboutwel/bg_model3.png") no-repeat;
  position: absolute;
  top: 227px;
  left: -27%;
  z-index: 2;
}
.model3_swiper {
  margin-top: 34px;
  width: 100%;
  height: auto;
  position: relative;
  z-index: 2;
  margin: 0 auto;
}
.personItem {
  border: 1px solid #dddddd;
  border-radius: 10px;
  background: url("../../public/img/aboutwel/newbg_model3.jpg") no-repeat;
  background-size: cover;
  padding: 64px 354px 10px 83px;
}
.personPic {
  width: 259px;
  height: 319px;
  background: #7b797c;
  border-radius: 50%;
  position: absolute;
  top: 96px;
  right: 65px;
  border: 1px solid #e4f0ff;
}
.personName {
  width: 100%;
  height: auto;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  margin-bottom: 21px;
}
.personSf {
  width: 100%;
  height: auto;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #409eff;
  margin-bottom: 39px;
  padding-left: 1px;
}
.personInfo {
  width: 100%;
  line-height: 1.5;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.model3_swiper .is-active {
  width: 946px !important;
  height: 448px !important;
  transform: translateX(200px) !important;
  background: url("../../public/img/aboutwel/newbg_model3.jpg") no-repeat;
  background-size: cover;
}

/* 荣誉资质 */
.model4 {
  padding-top: 60px;
  box-sizing: border-box;
  padding-bottom: 30px;
}

.model4Main {
  padding-top: 53px;
}
.model4floor {
  width: 100%;
  margin-bottom: 74px;
}
.model4_lf {
  width: 461px;
  float: left;
  height: 420px;
}
.model4_rt {
  width: 707px;
  height: 420px;
  float: right;
}
.model4_rt_title {
  height: auto;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 44px;
}
.model4_rt_title b {
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.model4_ul2 {
  width: 100%;
  height: 100%;
  overflow: auto;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  overflow: -moz-scrollbars-none;
  margin-bottom: 43px;
}
.model4_ul2::-webkit-scrollbar {
  display: none;
}
.model4_li2 {
  list-style: disc;
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  margin-bottom: 33px;
  height: 84px;
  overflow: hidden;
}
.model4_ul2 .model4_li2:nth-last-child(1) {
  margin-bottom: 0;
}
.model4_p1 {
  width: 72%;
  display: inline-block;
}
.model4_p2 {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  width: 28%;
  text-align: right;
  /* display: inline-block; */
  float: right;
  height: 100%;
  line-height: 42px;
}

/* 企业文化 */
.model5 {
  padding-top: 60px;
  height: 730px;
}
.model5_shadow {
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: -26%;
  z-index: 1;
  background: #f7f7f7;
}
.model5ul {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}
.model5li {
  width: 300px;
  height: 100%;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: 0px 0px 18px 0px rgba(70, 70, 70, 0.09);
  opacity: 0.93;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 59px;
}
.model5li:hover .model5icon,
.model5li:hover .model5title,
.model5li:hover .model5des {
  animation: AntIcon2 0.5s linear;
}

@keyframes AntIcon2 {
  0% {
    transform: scale(1.5);
    opacity: 0;
  }
  80% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* @keyframes AntFontLf {
  0% {
    transform: translateX(100px);
    opacity: 0;
  }
  80% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
} */

/* @keyframes AntFontRt {
  0% {
    transform: translateX(-100px);
    opacity: 0;
  }
  80% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
} */

.model5icon {
  width: 112px;
  height: 112px;
  margin-bottom: 23spx;
}
.model5title {
  height: auto;
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 19px;
}
.model5line {
  width: 16px;
  height: 2px;
  background: #999999;
  margin: 0 auto 29px;
}
.model5des {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 31px;
  white-space: pre-wrap;
}
.model5ul .model5li:last-child .model5des {
  line-height: 50px;
}

/* 大事记 */
.model6 {
  padding-top: 60px;
  /* width: 100%; */
  height: 700px;
}
/* 团队风采 */
.model7 {
  padding-top: 80px;
  height: auto;
  position: relative;
}
.model7shadow {
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: -26%;
  z-index: 1;
  background: #f7f7f7;
}

/* 小导航栏 */
/* .smTab {
  height: 85px;
  width: 100%;
  max-width: 7.083333rem;
  position: relative;
}
.smTab .el-tabs__item {
  font-size: 20px;
}
.smallLine {
  width: 100vw;
  height: 1px;
  background: #dddddd;
  position: absolute;
  bottom: 0;
  left: -20%;
} */
/* bannar图 */
.bigtitle {
  width: 100%;
  position: absolute;
  left: 0px;
  top: 137px;
  text-align: center;
}
.bannerdes1 {
  font-size: 76px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  line-height: 72px;
  margin-bottom: 32px;
  letter-spacing: 10px;
}
.bannerdes2 {
  font-size: 40px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  margin-bottom: 60px;
  letter-spacing: 3px;
}
.bannaerline {
  width: 68px;
  height: 6px;
  background: #cccccc;
  margin: 0 auto 41px;
}
.bannerdes3 {
  width: 100%;
  height: auto;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #fff;
  opacity: 0.7;
  letter-spacing: 3px;
}
.honorArr1 {
  width: 461px;
  height: 420px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.honorPic {
  width: 308px;
  height: 100%;
}

.model7main {
  position: relative;
  /* width: 100%; */
  margin: 0 auto;
  height: auto;
  overflow: hidden;
  border: 1px solid red;
}
.actItem {
  /* width: 1045px; */
  height: auto;
}
.actAll {
  display: flex;
  align-items: center;
  flex-direction: column;
  /* justify-content: center; */
}
.actPic {
  width: auto;
  height: 602px;
  border: 1px solid #589ef8;
  box-shadow: -1px 1px 9px 1px rgba(17, 126, 185, 0.68);
  margin-bottom: 26px;
}

.actName {
  width: 100%;
  text-align: center;
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 40px;
  display: none;
}
.model7main .is-active .actName {
  /* width: 1038px!important; */
  display: block;
}
.model7main .is-active {
  width: 80%;
  transform: translateX(12%) !important;
}
.mineVideo {
  width: 100%;
  height: 550px;
}

/* 大事记 */
.model6main {
  width: 100%;
  height: 745px;
  overflow: hidden;
  /* border: 1px solid red; */
}
.swiper1 {
  width: 100%;
  height: 82px;
  /* border: 1px solid red; */
  position: absolute;
  left: 66px;
  top: 128px;
}
.swiper1Line {
  width: 100%;
  height: 1px;
  background: #589ef8;
  border: 1px solid #dddddd;
  position: absolute;
  left: 0;
  bottom: 5px;
}
.mySwiper1,
.mySwiper2,
.mySwiper3 {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}

.list_li1_point {
  position: absolute;
  bottom: 0px;
  left: 49%;
  width: 13px;
  height: 13px;
  background: #999999;
  border-radius: 50%;
}
.list_li1_name {
  width: 100%;
  text-align: center;
  height: auto;
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  position: absolute;
  bottom: 20px;
  left: 0%;
}
.swiper2 {
  width: 82px;
  height: 700px;
  position: absolute;
  left: -10px;
  top: 202px;
}
.swiper2Line {
  width: 1px;
  height: 100%;
  background: #999999;
  border: 1px solid #dddddd;
  position: absolute;
  right: 4px;
  top: 0;
}
.list_li2_point {
  position: absolute;
  right: 0px;
  top: 75px;
  width: 13px;
  height: 13px;
  background: #999999;
  border-radius: 50%;
}
.list_li2_name {
  width: 100%;
  text-align: center;
  height: auto;
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  position: absolute;
  top: 53px;
  left: -10px;
}

.lcPic {
  width: 634px;
  height: 442px;
  position: absolute;
  left: 138px;
  top: 338px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lcPic image {
  width: auto !important;
  height: 100% !important;
}
.swiper3 {
  width: 500px;
  height: 450px;
  position: absolute;
  left: 180px;
  top: 265px;
}
.list_li3 {
  width: 100%;
  height: 100%;
  position: relative;
}
.list_li3_month {
  width: auto;
  height: auto;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.list_li3_point {
  width: 10px;
  height: 10px;
  background: #999999;
  border-radius: 5px;
  margin-right: 9px;
  display: inline-block;
}
.list_li3_thing {
  width: 100%;
  height: 80px;
  font-size: 24px;
  line-height: 1.6;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.fontBlue {
  color: #589ef8;
}

.bgBlue {
  background: #589ef8;
}
/* 定位坐标 */
.position {
  position: relative;
  z-index: -1;
  left: 0;
  top: -180px;
}

/* 公司简介的图片*/
.model1_floor2 .model1_pic {
  width: 100%;
  height: 3.25rem;
}

/* 2021-8-18新增 */
.videoModel2 {
  width: 100%;
  height: 600px;
}
.videoModel2 .btn_playVideo {
  left: 580px;
  top: 300px;
}
.model1_floor1_s {
  width: 100%;
  height: auto;
}
.model1_floor1_s .model1_context {
  height: 200px;
}
.model1_floor1_s .model1_context2 {
  height: 300px;
}

.item_detail {
  width: 421px;
  height: auto;
  background: #ebeaea;
  border: 1px solid #e6e8ec;
  box-shadow: 3px 5px 14px 1px #f2f2f2;
  border-radius: 10px;
  position: absolute;
  top: 700px;
  left: calc(50% - 210px);
  z-index: 2;
  padding: 24px;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  box-sizing: border-box;
}

.item_arrow {
  position: absolute;
  top: -20px;
  right: 60px;
  display: block;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 30px solid #ebeaea;
}
.swiperStrength {
  height: 320px;
  overflow: hidden;
}
.swiperStrength .swiper-slide {
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tips {
  font-size: 24px;
  line-height: 32px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  padding: 14px 0;
}
/* 样式 */

.Memorabilia {
  width: 100%;
  height: 445px;
  overflow: hidden;
  position: relative;
}
.Memorabilia .changeBtn {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-between;
  top: 40%;
  left: 0;
  z-index: 999;
}
.Memorabilia .meContent {
  width: fit-content;
  height: 100%;
}
.Memorabilia .meContent .contentTop {
  height: 50%;
  padding-left: 370px;

  border-bottom: 4px solid #e1f0ff;
  display: flex;
}
.Memorabilia .meContent .contentBottom {
  height: 50%;
  padding-left: 70px;
  display: flex;
}

.Memorabilia .meContent .content-item {
  height: 100%;
  width: 740px;
  display: flex;
}
.content-item .des {
  height: 95%;
  overflow: auto;
  padding-top: 14px;
}
.Memorabilia .meContent .contentTop .content-item::before {
  content: "";
  display: inline-block;
  height: 100%;
  width: 12px;
  background-image: url("../assets/top.png");
  background-size: 100% 100%;
  margin-right: 10px;
}
.content-item .time {
  font-size: 36px;
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: 500;
  color: #333333;
  line-height: 60px;
}
.content-item .context .tip {
  content: "";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: #7b797c;
  position: relative;
  top: 17px;
  margin-right: 4px;
}
.content-item .context {
  font-size: 20px;
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: 500;
  color: #666666;
  line-height: 42px;
  display: flex;
}
.Memorabilia .meContent .contentBottom .content-item::before {
  content: "";
  display: inline-block;
  height: 100%;
  width: 12px;
  background-image: url("../assets/bottom.png");
  background-size: 100% 100%;
  margin-right: 10px;
}
</style>
